import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import axiosHttp from "services/axiosHttp";

//create action
export const createLocation = createAsyncThunk(
  "createLocation",
  async ({ data, form, history }) => {
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };
    const response = await axiosHttp.post(
      `location/create`,
      data,
      config
    );

    form.resetFields();
    message.success("Location successfully created!");
    history("/app/organization/location");
    return response.data;
  }
);

const locationCreateSlice = createSlice({
  name: "locationCreate",
  initialState: {
    isLoading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(createLocation.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(createLocation.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(createLocation.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default locationCreateSlice.reducer;